<template>
<div>
    <div class="monitor-box">
        <div class="columns is-multiline">
            <div class="column is-10 p-bottom-0">
                <div class="name">
                    <router-link :to="{ name: 'showFile', params: { id: file.id } }"><a>{{ file.name }}</a></router-link>
                </div>
            </div>
            <div class="column is-2 has-text-right" style="padding-bottom:0;">
                <div class="icon-container tooltip is-tooltip-top" :data-tooltip="statusIconTooltip">
                    <font-awesome-icon v-if="showDeletedFromProviderIcon" :icon="['far', 'times-circle']" class="has-text-danger" />
                    <font-awesome-icon v-if="showActiveStatusIcon" icon="check-circle" class="has-text-success" />
                    <font-awesome-icon v-if="showPausedStatusIcon" icon="pause-circle" class="has-text-warning" style="font-size: 22px;" />
                </div>
            </div>
            <div class="column is-12" style="padding-top:0;padding-bottom:0">
                <div class="belongs-to">
                    Daily - 
                    <router-link :to="{ name: 'serverSettings', params: { id: file.server.id } }"><a>{{ file.server.name }}</a></router-link>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <div class="tooltip is-tooltip-top" :data-tooltip="lastBackupAtTooltip">
                    <p class="detail-label">Last backup</p>
                    <p class="detail-value">{{ file.last_backup_human_diff ? file.last_backup_human_diff : '-' }}</p>
                </div>
            </div>
            <div class="column is-4 widget-update-tolerated-delay">
                <div class="tooltip is-tooltip-top" :class="{ 'is-tooltip-multiline': false }" :data-tooltip="nextBackupAtTooltip">
                    <p class="detail-label">Next backup</p>
                    <p class="detail-value">{{ file.next_backup_human_diff ? file.next_backup_human_diff : '-' }}</p>
                </div>
            </div>
            <div class="column is-4">
                <div class="tooltip is-tooltip-top" :data-tooltip="backupsCountTooltip">
                    <p class="detail-label">Backups</p>
                    <p class="detail-value">{{ file.backups_count }}</p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">

                <div class="tooltip is-tooltip-top" :data-tooltip="togglePausedTooltip">
                    <div @click="togglePaused" :disabled="false" :class="{ 'is-info': file.paused, 'is-warning': !file.paused }" class="pause-monitor button is-fullwidth">
                        <font-awesome-icon v-if="!file.paused" icon="pause"/>
                        <font-awesome-icon v-if="file.paused" icon="play"/>
                    </div>
                </div>
            </div>
            <div class="column is-4">
                <div class="tooltip is-tooltip-top" :data-tooltip="snapshotNowTooltip">
                    <div @click="backupNow" :disabled="false" class="button is-info is-fullwidth">
                        <font-awesome-icon icon="save"/>
                    </div>
                </div>
            </div>
            <div class="column is-4">
                <router-link :to="{ name: 'showFile', params: {id: this.file.id} }">
                    <div class="button is-default-custom is-fullwidth tooltip is-tooltip-top" :data-tooltip="configureBackupSettingsTooltip">
                        <font-awesome-icon :icon="['fas', 'calendar']"/>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// import FormattedScheduleMixin from '../../components/Mixins/FormattedSchedule.js';
import Api from '@/api';
import Swal from 'sweetalert2';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    props: ['file','cloudlet'],

    methods: {
        showCloudletDetails() {
            Event.$emit('showCloudletDetails');
        },

        backupNow() {
            let endpoint = 'files/' + this.file.id + '/backups';
            Api().post(endpoint)
                .then((response) => {
                    Swal.fire({
                        title: 'Great!',
                        text: 'The backup was enqueed and will be picked up by a worker as soon as possible.',
                        type: 'success',
                    });
                })
                .catch((error) => {
                    if (error.response.status == 409) {
                        Swal.fire({
                            title: 'Oops',
                            text: 'The last backup is still pending or in progress. Wait until it\'s done before creating a new one.',
                            type: 'error',
                        });
                    } else if (error.response.status == 423) {
                        Swal.fire({
                            title: 'Oops',
                            text: 'This file schedule does not have a cloud storage. Attach one and try again.',
                            type: 'error',
                        });
                    } else {
                        Swal.fire({
                            title: 'Oops',
                            text: 'Something wrong happened. Our team got notified and will investigate the problem.',
                            type: 'error',
                        });
                    }
                });
            // if (!this.cloudlet.snapshots_allowed) {
            //     return;
            // }

            // Swal.fire({
            //     title: 'One moment',
            //     text: 'The snapshot is in progress.',
            //     type: 'info',
            //     allowOutsideClick: () => !Swal.isLoading(),
            //     allowEscapeKey: () => !Swal.isLoading(),
            //     onBeforeOpen: () => {
            //         Swal.showLoading();

            //         Api().get('cloudlets/' + this.cloudlet.id + '/snapshots/last')
            //             .then((response) => {
            //                 if (response.data.data.in_progress) {
            //                     // last snapshot is still in progress, new snapshots are not allowed
            //                     Swal.fire({
            //                         title: 'Oops',
            //                         text: 'The last snapshot of this cloudlet is still in progress. Wait until is done before creating a new one.',
            //                         type: 'error',
            //                     });
            //                     return;
            //                 }
            //                 this.makeRequestToCreateSnapshot();
            //             })
            //             .catch((error) => {
            //                 if (error.response.status == 404) {
            //                     this.makeRequestToCreateSnapshot();
            //                 }
            //             })
            //             .finally(() => {
            //                 //
            //             });
            //     },
            // });
        },

        togglePaused() {
            // if (this.cloudlet.deleted_from_provider) {
            //     return;
            // }

            Swal.fire({
                title: 'One moment',
                text: 'The cloudlet is being modified.',
                type: 'info',
                allowOutsideClick: () => !Swal.isLoading(),
                allowEscapeKey: () => !Swal.isLoading(),
                onBeforeOpen: () => {
                    Swal.showLoading();

                    let endpoint = 'files/' + this.file.id + '/paused';
                    return Api().put(endpoint)
                        .then((response) => {

                            Event.$emit('refreshFiles', () => {
                                var action = 'paused';
                                var title = 'Done!';

                                if (this.file.paused) {
                                    action = 'resumed';
                                    title = 'Great!';
                                }

                                Swal.fire({
                                    // animation: false,
                                    title: title,
                                    text: 'The automatic file backups for ' + this.file.name + ' are ' + action + '.',
                                    type: 'success',
                                });
                            });
                        })
                        .catch((error) => {
                            if (typeof error.response.data.message == 'string' && typeof error.response.data.title == 'string') {
                                var title = error.response.data.title;
                                var message = error.response.data.message;
                            } else {
                                var title = 'Ooops';
                                var message = 'Something wrong happened.';
                            }

                            Swal.fire({
                                title: title,
                                text: message,
                                type: 'error',
                            });
                        })
                        .finally(() => {
                            //
                        });
                },
            });
        },

        makeRequestToCreateSnapshot() {
            let endpoint = 'cloudlets/' + this.cloudlet.id + '/snapshots';
            Api().post(endpoint)
                .then(() => {
                    //
                })
                .catch(() => {
                    //
                })
                .finally(() => {
                    Event.$emit('refreshAccountCloudlets', this.cloudlet.account.id, () => {
                        Swal.fire({
                            title: 'Great!',
                            text: 'Snapshot is in progress.',
                            type: 'success',
                        });
                    });
                });
        },
    },

    computed: {
        frequencyLabel() {
            let frequencyHours = this.file.frequency.hours;
        
            if (frequencyHours == 24) {
                return 'Daily';
            }

            if (frequencyHours == 1) {
                return 'Every hour';
            }

            return 'Every ' + frequencyHours + ' hours';
        },

        fileUrl() {
            return '/files/' + this.file.id;
        },

        showPausedStatusIcon() {
            return this.file.paused;
        },

        showActiveStatusIcon() {
            return !this.file.paused;
        },

        showDeletedFromProviderIcon() {
            return false;
            // return this.file.deleted_from_provider;
        },

        statusIconTooltip() {
            if (this.showActiveStatusIcon) {
                return 'File backups are taken as configured.';
            }

            if (this.showPausedStatusIcon) {
                return 'File backups are paused.';
            }

            if (this.showDeletedFromProviderIcon) {
                return 'This cloudlet was deleted from the provider.';
            }
        },

        cloudletName() {
            if (this.cloudlet.name.length > 42) {
                return this.cloudlet.name.slice(0, 42) + '...';
            }

            return this.cloudlet.name;
        },

        cloudletDescription() {
            return 'todo';
            // if (!this.cloudlet.ip_address) {
            //     return this.frequencyLabel;
            // }

            // return this.frequencyLabel + ' - ' + this.cloudlet.ip_address;
        },

        togglePausedTooltip() {
            // if (this.cloudlet.deleted_from_provider) {
            //     return 'Further actions are not possible anymore.';
            // }

            // if (this.cloudlet.paused) {
            //     return 'Snapshots are paused for this cloudlet. Click to resume.';
            // }

            return 'File backups are taken as configured. Click to pause.'
        },

        snapshotNowTooltip() {
            // if (this.cloudlet.deleted_from_provider) {
            //     return 'Further actions are not possible anymore.';
            // }

            return 'Create a manual file backup now.';
        },

        configureBackupSettingsTooltip() {
            // if (this.cloudlet.deleted_from_provider) {
            //     return 'Further actions are not posible anymore.';
            // }

            return 'Configure backup settings of the cloudlet.';
        },

        backupsCountTooltip() {
            if (this.file.backups_count < 1) {
                return 'Weap.io didn\'t create a backup for this file schedule yet.';
            }

            return 'Weap.io created ' + this.file.backups_count + ' backups that are active now.';
        },

        nextBackupAtTooltip() {
            // if (this.file.deleted_from_provider) {
            //     return 'Not scheduled because the cloudlet was deleted from the provider.';
            // }

            if (this.file.paused) {
                return 'Not scheduled because the file schedule is paused.';
            }

            return 'Will start at ~' + this.file.next_backup_at + ' UTC';
        },

        lastBackupAtTooltip() {
            if (!this.file.last_backup_at) {
                return 'No backup was taken yet.';
            }
            return 'Started at ' + this.file.last_backup_at + ' UTC';
        },
    },
}
</script>
